import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {AnalyticsService} from '../components/analytics-service/analytics.service';
import {FirebaseService} from '../components/firebase-service/firebase-service.service';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss']
})
export class PortfolioComponent implements OnInit {

  projects: any[];
  tags: [];
  dataPath = 'portfolio/';

  constructor(private analyticsService: AnalyticsService, private firebaseService: FirebaseService) {
    this.analyticsService.emitEvent(
      'Page visit',
      'Portfolio'
    );
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }
  getRandomTag() {
    return 'btn-outline-' + this.tags[this.getRandomInt(this.tags.length)];
  }

  ngOnInit(): void {
    // @ts-ignore
    this.tags = [
      'dark',
      'dark',
      'primary',
      'primary',
      'primary',
      'secondary',
      'secondary',
      'danger',
      'danger',
      'warning',
      'warning',
      'warning',
      'warning',
      'info',
      'info',
      'info',
      'info',
      'success',
      'success',
      'success',
      'success',
    ];
    this.projects = [];
    this.firebaseService.getCollection(this.dataPath, 'order_index').subscribe(res => {
      this.projects = [];
      // @ts-ignore
      for (const project of res) {
        const projCp = project;
        projCp.tags = [];
        if (!!project.tag) {
          for (const tag of project.tag.split(',')) {
            const mytag = {
              name: tag,
              color: this.getRandomTag()
            };
            projCp.tags.push(mytag);
          }
        }
        this.projects.push(projCp);
      }
    });

    /*
      {
        title: 'Real-World Data Cockpit',
        subtitle: 'Quality Assessment tool for ranking RWD',
        content: 'As the new front of Digital Biomarkers quickly expands, Real-World Data (RWD) is the largest domain of application, ' +
          'be it for data collection, hypothesis testing and/or generation of Real-World Evidence. Several parallel efforts already ' +
          'define RWD/RWE, however an overall systematic view of the domain and data quality assessments for clinical use are missing. ' +
          'We use an indexing workflow to address the systematic organization of RWD by focusing on identifiers for describing the ' +
          'quality, standardization, regulation, and privacy of RWD datasets. These variables are Quality Identifiers (QI) and provide ' +
          'a first quality assessment and validation for the use of RWD in a clinical setting. We developed the RWD Cockpit, ' +
          'a dashboard to view and assess the quality of RWD. The RWD Cockpit is a practical database which allows the management of ' +
          'QIs and their possible scores. By using this QI list of quality metrics, we index available RWD datasets and provide an ' +
          'overall Quality Score (QS) for the dataset. The system equips each RWD dataset with a unique ID and a deep-link allowing to ' +
          'share quick details as well as off-the-shelf database features such as advanced searching and filtering. The RWD Cockpit ' +
          'is a complete tool to assess quality of RWD for clinical use.',
        image: '../../assets/img/projects/rwd.png',
        tags: [
          {
            name: 'RWD / RWE',
            color: this.getRandomTag()
          },
          {
            name: 'Index',
            color: this.getRandomTag()
          },
          {
            name: 'Customizable QI',
            color: this.getRandomTag()
          },
          {
            name: 'API',
            color: this.getRandomTag()
          },
          {
            name: 'Live data streams',
            color: this.getRandomTag()
          },
          {
            name: 'Digital Biomarkers',
            color: this.getRandomTag()
          },
        ]
      },
      {
        title: 'Personalis',
        subtitle: 'EHR Patient Stratification Tool',
        content: 'Autoimmune diseases (AID) such as systemic lupus erythematosus and multiple sclerosis are stably increasing in ' +
          'particular in Western countries. Currently, there are no available cures or universally available treatments. In 2015, ' +
          '18 Phase 2/3 clinical trials in systemic lupus erythematosus were unsuccessful, probably as a result of patient ' +
          'stratification.' +
          'This lack of stratification can lead to under-informed drug administration and possibly lack of patient response, ' +
          'particularly when we factor in the high diversity incurred either from molecular perspective to macro-factors such as' +
          ' comorbidities. In order to address this problem, we have built the first iteration of a decision-support system, ' +
          'the Personalis software. Personalis is a platform for physicians that will facilitate and optimize the biological ' +
          'stratification of patients and their management.',
        image: '../../assets/img/projects/personalis.png',
        tags: [
          {
            name: 'DSS',
            color: this.getRandomTag()
          },
          {
            name: 'EHR',
            color: this.getRandomTag()
          },
          {
            name: 'Agile Pivot',
            color: this.getRandomTag()
          },
          {
            name: 'Datacube',
            color: this.getRandomTag()
          },
          {
            name: 'Hypothesis testing',
            color: this.getRandomTag()
          },
          {
            name: 'Patient Stratification',
            color: this.getRandomTag()
          },
        ]
      },
      {
        title: 'Master of Science in Medical Informatics',
        subtitle: '',
        content: '<p>The FHNW University of Applied Sciences and Arts offers a new master program in Medical Informatics' +
          ' as a cooperation ' +
          'of the School of Life Sciences and School of Business regarding the application of digital technologies and artificial ' +
          'intelligence in healthcare. </p>' +
          '<p>The master’s program is in English and focuses on the latest information technology for the ' +
          'medical and pharmaceutical industries. Students will acquire knowledge and learn methods from the field of IT and develop' +
          ' expertise in biomedical data analysis, the application of artificial intelligence, visualization technologies, the handling ' +
          'of big data and related economic issues. As an example, the program will address the question of how digitalization ' +
          'impacts drug discovery and development, hospital processes and the health sector in general. An important focus of the ' +
          'master’s is personalized medicine. Work related to digital data opens up further education and application areas on data ' +
          'security, control mechanisms, decision-making models and ethical issues. </p>' +
          '<p>The numerous internships during the program will ' +
          'enable students to analyze health data as well as apply and develop software for hospitals and the pharmaceutical industry. ' +
          'Leading providers from the healthcare industry will be actively involved in the study program and will address ' +
          'innovative topics in seminars. </p>' +
          '<p>The program provides current know-how on the following areas:</p>',
        image: '../../assets/img/projects/meding.png',
        tags: [
          {
            name: 'Digital transformation in healthcare',
            color: this.getRandomTag()
          },
          {
            name: 'Biomedical data science',
            color: this.getRandomTag()
          },
          {
            name: 'Medical software development',
            color: this.getRandomTag()
          },
          {
            name: 'Digitalization of processes',
            color: this.getRandomTag()
          },
          {
            name: 'Compliance management and governance IT',
            color: this.getRandomTag()
          },
          {
            name: 'Business intelligence',
            color: this.getRandomTag()
          },
          {
            name: 'Machine learning in personalized medicine',
            color: this.getRandomTag()
          },
          {
            name: 'Knowledge processing and decision making',
            color: this.getRandomTag()
          },
          {
            name: 'Artificial intelligence in drug discovery',
            color: this.getRandomTag()
          },
        ]
      },
      {
        title: 'Prediction of an antigen-specific antibody sub-repertoire using zebrafish',
        subtitle: '',
        content: '<p>Immunotherapeutic drugs are important biologics and blockbusters against infectious diseases and cancer. ' +
          'The portion of the antibody repertoire against a given pathogen represents its specific antibody sub-repertoire. ' +
          'Knowledge about a pathogen-specific antibody sub-repertoire would tremendously fasten drug discovery in personalized ' +
          'medicine, e.g., in the discovery of novel antibodies against cancer neo-epitopes. However, the identification of ' +
          'pathogen-specific antibodies not been resolved. Danio rerio (zebrafish) represent one of the earliest recognizable ' +
          'animals that have evolved an adaptive immune system that is similar to humans. They contain Ig gene loci that are ' +
          'both similar organizationally and contain genes that are similar tor human antibody development including the combinational ' +
          'rearrangement of antibody gene segments (variable, diverse, junctional), and somatic hypermutation. ' +
          'Using current antibody sequencing techniques, the entire zebrafish antibody repertoire can be captured using ' +
          'next-generation sequencing. We aim to investigate the pathogen-specific antibody sub-repertoire in the zebrafish ' +
          'animal model in order to lay the foundations towards the identification and prediction of sub-repertoires in a ' +
          'generalized framework. </p>',
        image: '../../assets/img/projects/zebrafisch.jpg',
        tags: [

        ]
      },
      {
        title: 'Benchmarking immunoinformatic tools for the analysis of antibody repertoire sequences',
        subtitle: '',
        content: '<p>Antibody repertoires reveal insights into the biology of the adaptive immune system and empower diagnostics ' +
          'and therapeutics. There are currently multiple tools available for the annotation of antibody sequences. ' +
          'However, a thorough comparison of the performance of these tools has not been investigated. We benchmarked the ' +
          'performance of commonly used immunoinformatics tools, i.e., IMGT/HighV-QUEST, IgBLAST, and MiXCR, in terms of ' +
          'annotation output, accuracy and speed using simulated and experimental datasets. Using the same testing conditions, ' +
          'we compared the tools’ ability to annotate sequences to V, D, and J genes. We found that the tools resulted in ' +
          'diverging outcomes. In terms of alignment accuracy, MiXCR had the highest average frequency of gene mishits, ' +
          '0.02 mishit frequency, and IgBLAST the lowest, 0.004 mishit frequency. Reproducibility in the output complementarity ' +
          'determining 3 regions (CDR3 a.a.) ranged from 11 to 28%. Run time for the tools was assessed and MiXCR was the ' +
          'fastest tool for annotation output per unit of time. Results indicate that immunoinformatic analyses greatly depend ' +
          'on the choice of bioinformatics tool. Our results provide a basis to support informed decision-making to ' +
          'immuno-informaticians based on repertoire composition and sequencing platforms.</p>' +
          '<p><span style="font-size: 12pt;color: #000000;background-color: transparent;vertical-align: baseline;">' +
          'Smakaj E*, Babrak LM*, Ohlin M, Shugay M, Briney B, Tosoni D, Galli D, Grobelsek V, D’Angelo I, Olson B, Watson C, ' +
          'Reddy S, Greiff V, Trück J, Marquez S, Lees W, Miho E. </span><span style="font-size: 12pt;color: #000000;backgro' +
          'und-color: transparent;vertical-align: baseline;"><i>Benchmarking immunoinformatic tools for the ana' +
          'lysis of antibody repertoire sequences. Manuscript submitted for publication</i></span>' +
          '<span style="font-size: 12pt;color: #000000;background-color: transparent;vertical-align: baseline;">. (Submitted). </span></p>',
        image: '../../assets/img/projects/benchmarking.png',
        tags: [

        ]
      },
      {
        title: 'Predicting personal immune scenarios',
        subtitle: '',
        content: 'Antibodies neutralize pathogens and are important for diagnostics and therapeutics. The antibody repertoire is the ' +
          'vast collection of distinct B cell receptors and secreted antibodies that are each represented by a sequence of amino acids. ' +
          'The theoretical diversity of antibody repertoire counts 10140 possible entities.  Each antibody is arranged into two  chains,' +
          ' approximately 110 a.a. long consisting of a unique combination of 20 amino acids (a.a.). B cell kinetics results in an ' +
          'ever-changing personalized antibody repertoire and a dynamic immune status. The record of sequence diversity in antibody ' +
          'repertoires has been recently made available from the advancement of high-throughput sequencing technologies. Antibody ' +
          'repertoires can now be represented as large-scale networks where antibodies are sequence-nodes connected by similarity-edges, ' +
          'have an exponential structure. Thus, network analysis can capture sequence relations in this complex system, track the ' +
          'potential proliferation and predict the disappearance of certain sequence features. We use high-throughput sequencing data ' +
          'combined with network analysis to measure, track and predict the change in sequence space of the antibody repertoire.' +
          ' We show how this network model can serve as the base to track entire personalized antibody repertoires in the theoretical ' +
          'antibody sequence space, thus predicting immune status scenarios.',
        image: '../../assets/img/projects/medict.png',
        tags: [

        ]
      },
      {
        title: 'Integration of digital biomarkers into healthcare',
        subtitle: '',
        content: '<p>The identification and application of biomarkers in the clinical and medical fields has an enormous impact ' +
          'on society. The increase of digital devices and the rise in popularity of health-related mobile apps has produced a new ' +
          'trove of biomarkers in large, diverse, and complex data. However, the unclear definition of digital biomarkers, ' +
          'population groups, and their intersection with traditional biomarkers, hinders their discovery and validation. ' +
          'We identify current issues in the field of digital biomarkers and put forth suggestions to address them during the ' +
          'DayOne Workshop with participants from academia, industry and regulatory agencies. We find similarities and differences' +
          ' between traditional and digital biomarkers in order to synchronize semantics, define unique features, review current ' +
          'regulatory procedures and describe novel applications that enable precision medicine. This provides the community with ' +
          'valuable insights into the challenges and possible solutions for the integration of digital biomarkers into healthcare.</p>'+
          '<p dir="ltr" style="text-align: justify;"><span style="font-size: 12pt;color: #000000;background-color: ' +
          'transparent;vertical-align: baseline;">Babrak, LM, Menetski J, Rebhan M, Nisato G,  Zinggeler M, Brasier N, ' +
          'Baerenfaller K, Brenzikofer T, Baltzer L, Vogler C, Gschwind L, Schneider C, Streiff F, Groenen PMA and Miho E. (2019). ' +
          'Traditional and Digital Biomarkers – two worlds apart? </span><span style="font-size: 12pt;' +
          'color: #000000;background-color: transparent;vertical-align: baseline;"><i>Digital Biomarkers</i></span>' +
          '<span style="font-size: 12pt;color: #000000;background-color: transparent;vertical-align: baseline;">. ' +
          'Forthcoming. DOI: 10.1159/502000</span></p>',
        image: '../../assets/img/projects/medict.png',
        tags: [

        ]
      },
    ];
    */
  }

}
